var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useContext } from "react";
import { Typography } from "../../../index";
import { ThemeContext } from "styled-components";

var Link = function Link(_ref) {
  var displayName = _ref.displayName,
      onClick = _ref.onClick,
      style = _ref.style;
  return React.createElement(
    Typography,
    {
      $as: "span",
      bold: true,
      size: 2,
      style: _extends({}, style, {
        padding: "0.375rem 1rem"
      }),
      onClick: onClick
    },
    displayName
  );
};

export var MenuLinksMobile = function MenuLinksMobile(_ref2) {
  var wrapLink = _ref2.wrapLink,
      navAtTop = _ref2.navAtTop,
      menuContent = _ref2.menuContent,
      currentPathname = _ref2.currentPathname,
      setOpen = _ref2.setOpen;

  var theme = useContext(ThemeContext);

  return menuContent.links.filter(function (link) {
    return link.showOnMobile;
  }).map(function (linkProps, i) {
    if (currentPathname === linkProps.url) {
      return React.createElement(Link, _extends({
        key: i,
        navAtTop: navAtTop,
        onClick: function onClick() {
          return setOpen(false);
        },
        style: { color: theme.colors.corePink }
      }, linkProps));
    } else {
      var linkContent = React.createElement(Link, _extends({ key: i }, linkProps, { navAtTop: navAtTop }));
      return wrapLink(linkContent, linkProps);
    }
  });
};